const SEOImageCard = ({ imageSrc, bgColor, source }) => {
  const styleClass =
    source === "demo"
      ? "h-[290px] w-[86%]"
      : source === "security"
        ? "h-[300px] w-[86%]"
        : "h-[70%] w-[70%]";

  return (
    <div className="w-full pr-[10px] md:pr-[28px] pl-[10px] md:pl-0">
      <div
        className="w-full h-[350px] md:h-[560px] rounded-[10px] flex items-center justify-center"
        style={{ backgroundColor: bgColor }}
      >
        <div className={`${styleClass} rounded-[10px] overflow-hidden ml-[10px]`}>
          <img
            src={imageSrc}
            alt="Eveness product description"
            className="w-full h-full object-contain"
            loading="lazy"
          />
        </div>{" "}
      </div>
    </div>
  );
};

export default SEOImageCard;
